import React, { createContext, useCallback, useContext, useState } from "react";
import ReserveDialog from "../components/ReserveDialog";

const ReserveContext = createContext();

export const ReserveProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const openReserve = useCallback(() => setOpen(true), []);
  const closeReserve = useCallback(() => setOpen(false), []);
  const onSuccess = useCallback(() => setRefreshKey((k) => k + 1), []);

  return (
    <ReserveContext.Provider value={{ open, openReserve, closeReserve, refreshKey }}>
      {children}
      <ReserveDialog open={open} onClose={closeReserve} onSuccess={onSuccess} />
    </ReserveContext.Provider>
  );
};

export const useReserve = () => useContext(ReserveContext);
